<div class="d-flex flex-column w-100 w-sm-60 mx-auto py-5">
    <app-email-verification-cta-vector class="mx-auto"></app-email-verification-cta-vector>

    <div class="d-flex mx-auto mt-4ee p-2e">
        <p class="mb-auto mat-headline-5 fw-bold">Verify your email address</p>
    </div>

    <span class="mx-auto mt-3 mb-0 mat-body-1" style="line-height: normal;">Enter the verification code that was
        sent to your mail to complete your registration</span>

    <!-- INFO Code blocks -->
    <div class="d-flex w-100 my-4e justify-content-between">
        <input #otpBoxes *ngFor="let item of [1,2,3,4,5,6]; index as i;" [formControl]="getControlAt(i)"
            class="w-48px h-48px mb-0 p-2 mat-h1  text-center bg-light border-1 border-primary rounded-3"
            type="text" minlength="1" (keyup)="onKeyUp(i, $event)">
    </div>

    <button mat-flat-button class="px-3 py-4 fw-bold rounded-3e" color="primary" [disabled]="inProgress || form.invalid" (click)="completeEmailVerification()">
        <span class="my-auto mat-body-1 fw-bold">Verify</span>
    </button>

    <p class="mx-auto mt-4 mb-0 p-2e mat-body-1">
        Didn't receive one?
        <!-- INFO Should perform action on click -->
        <a mat-button class="ms-1 text-primary cursor-pointer" [disabled]="inProgress" (click)="resendEmailVerification()">Resend Code</a>
    </p>
</div>
